export function initializeFrontendBlocks(blockName, initializeBlock) {
	// Initialize each block on page load (front end).
	window.addEventListener('DOMContentLoaded', function() {
		const blockElements = document.querySelectorAll(`.wp-block-aptum-${blockName}`);

		blockElements.forEach(function(blockElement) {
			initializeBlock(blockElement);
		});
	});
}

export function initializeEditorBlocks(blockName, initializeBlock) {
	// Initialize dynamic block preview (editor).
	if( window.acf ) {
		window.acf.addAction(
			`render_block_preview/type=aptum/${blockName}`,
			function($block, r) {
				const block = $block[0];

				if (!block) {
					return;
				}

				const blockElement = block.classList.contains(`wp-block-aptum-${blockName}`)
					? block
					: block.querySelector(`.wp-block-aptum-${blockName}`);

				if (blockElement) {
					initializeBlock(blockElement);
				}
			}
		);
	}
}
